import * as axios from 'axios';
import { LoggedUserInformation } from '@/login/loginModel';

const url = `${process.env.VUE_APP_API_URL}/account`;


export default function facebookLogin(code: string, referralUserId: string | undefined) {
    return axios.default.post<LoggedUserInformation>(`${url}/facebookLogin`, { facebookToken: code, referralUserId });
}
